import { render, staticRenderFns } from "./myPlan.vue?vue&type=template&id=52e89967"
import script from "./myPlan.vue?vue&type=script&lang=js"
export * from "./myPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports